import { component } from 'picoapp';

// Utils
import { setCSSProperty } from 'utils/css';

export default component(async (node) => {
  const classes = {
    active: 'collapsible--active',
  };

  let isActive = false;
  const title = node.querySelector('[data-title]');
  const content = node.querySelector('[data-content]');

  const event = new CustomEvent('action:collapsible:toggle', {
    detail: {
      group: node.dataset.group,
      element: node,
    },
  });

  const open = () => {
    node.classList.add(classes.active);

    setCSSProperty(content, '--height', `${content.scrollHeight}px`);

    isActive = true;
  };

  const close = () => {
    node.classList.remove(classes.active);
    setCSSProperty(content, '--height', 0);

    isActive = false;
  };

  title.addEventListener('click', () => {
    if (isActive) {
      close();
    } else {
      open();
    }

    document.dispatchEvent(event);
  });

  document.addEventListener('action:collapsible:toggle', ({ detail }) => {
    if (detail.group === node.dataset.group && detail.element !== node) {
      close();
    }
  });
});
